<template>
  
  <v-combobox
                            v-model="answer.options"
                            :items="question.options"
                            ref="combobox"
                            flat
                            dense
                            solo
                            hide-details
                            autofocus
                            multiple
                            @change="update"
                            @focus="edit==true"
                            class="ma-0 pa-0"
                            :small-chips="edit"
                            placeholder="..."
                            style="font-size: inherit;font-family: inherit;"
                            append-icon
                          >
                           
        </v-combobox>
    <!--v-card v-else flat color="transparent" class="mx-auto">
    
     <v-layout v-if="edit || answer.options.length==0" row class="pl-2" @blur="update" v-closable="{
              exclude: ['check_display'],
              handler: 'update'
            }">
      <v-flex xs4 v-for="(q, ii) in question.options"><v-checkbox v-model="answer.options" :value="q" class="ma-0" :label="q" @change="change" style="display:block"></v-checkbox></v-flex>
      <v-flex xs4 style="z-index:10">
        <v-checkbox :value="newValue" class="ma-0" @change="change" :readonly="true" style="display:block" @click.prevent="$refs.add.focus()">
          <template v-slot:label>
            <v-text-field 
                      v-model="newValue"
                      ref="add"
                      hide-details
                      placeholder="..."
                      @keydown.enter="change"
                      
                      class="minimal body-2 border-less indigo--text lighten-3 my-0 py-0"
                                          >
                          </v-text-field>
          </template>  
      </v-checkbox></v-flex>
    </v-layout>
    <span ref="check_display" v-show="!edit && answer.options.length > 0" @click="edit=true">{{answer.options.join(', ')}}</span>
            <v-card-actions v-if="false">
              <v-spacer></v-spacer>
                <v-btn text @click="update">Opslaan</v-btn>
            </v-card-actions>
        </v-card-->
</template>
<script>

export default {
  props: {
     menu: {
        type: Boolean,
        default: false
      },
      current: {
        type: Boolean,
        default: false
      },
      question: {
        type: Object,
        default: () => {}
      },
      answer: {
        type: Object,
        default: () => {}
      }
    },
   data: () => ({
      props: {"closeOnClick":false, "closeOnContentClick":false, "openOnClick":true, "maxHeight":300, "offsetY":true, "offsetOverflow":true, "transition":false},
      newValue:null,
      edit: false
  }),
  computed: {
  },
  mounted() {
    var self = this
    this.question.edit = false
        this.$nextTick(() => {
           if (self.menu) self.$refs.combobox.activateMenu()
          })
  },
  methods: {
    change() {
      if (!this.newValue || this.newValue == "") return false
      if (this.question.options.indexOf(this.newValue) > -1) return false
      this.question.options.push(this.newValue)
      this.answer.options.push(this.newValue)
      this.newValue = ""
      console.log(this.answer.options)
    },
    activateMenu(){
      this.$refs.combobox.activateMenu()
    },
    update() {
        this.edit=false
        this.question.options = [... new Set(this.question.options.concat(this.answer.options))]
        if (!this.answer || !this.answer.question) return this.$emit('update',this.answer.text,this.answer) 
        this.$emit('update', this.question)
    }
  }
}
function isEven(value) {
	if (value%2 == 0)
		return true;
	else
		return false;
}
</script>
<style>
  .google-doc .v-text-field.v-text-field--enclosed .v-text-field__details, 
  .google-doc .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
    margin: 0px;
    padding: 0px;
  }
  .google-doc .v-text-field--filled > .v-input__control > .v-input__slot, 
  .google-doc .v-text-field--full-width > .v-input__control > .v-input__slot, 
  .google-doc .v-text-field--outlined > .v-input__control > .v-input__slot {
      min-height: 20px;
      height:20px;
  }
  .v-text-field.v-text-field--solo .v-input__control {
    min-height:24px!important;
  }
  .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
      margin-bottom: 0px!important;
  }
</style>
